<template>
  <Layout>
    <div
      class="bg-red-100 text-red-900 p-4 lg:flex items-center justify-left gap-2 rounded-lg my-8 text-center lg:text-left"
    >
      <vue-feather type="alert-triangle" class="h-8 mx-auto lg:mx-0" />
      <div class="lg:ml-8">
        <header class="font-bold">Real Estate Agent Jobs Only</header>
        <p class="mt-1">
          Right now, Humaniz only supports hiring for Real Estate Agents and not other roles. Other roles will be coming
          in the future. Please stayed tuned.
        </p>
      </div>
    </div>
    <DetailForm
      title="New"
      description="This form will create a new job. Jobs are publicly available for candidates to apply to and may be aggregated to job portals."
      action="Create"
      @handle-cancel="$router.go(-1)"
      @handle-action="createJob"
    >
      <TextInput
        label="Title"
        placeholder="Real Estate Agent"
        :model-value="jobData.title"
        @update:model-value="value => (jobData.title = value)"
      />
      <GoogleMapsInput
        v-model="jobData.location"
        label="Location"
        autocomplete-type="city"
        help-text="We recommend adding 7 nearby cities for each job. This helps get you in front of the most candidates."
      />
      <ToggleInput
        v-model="jobData.resume_required"
        label="Resume Required"
        description="Require applicants to submit a resume when applying for this position"
      />
      <template #footer>
        <QuillInput
          v-model="jobData.description"
          :editor-toolbar="customToolbar"
          label="Description"
          name="job-description"
          size="x-large"
        />
      </template>
    </DetailForm>
  </Layout>
</template>

<script>
import Layout from '../Layout/index.vue';
import DetailForm from '../shared/DetailForm.vue';
import GoogleMapsInput from '../shared/GoogleMapsInput.vue';
import StatesUtility from '../../utilities/states.js';
import { createJob } from '../../api/jobs.ts';
import QuillInput from '../shared/QuillInput.vue';
import ToggleInput from '../shared/ToggleInput.vue';

export default {
  components: {
    Layout,
    DetailForm,
    GoogleMapsInput,
    QuillInput,
    ToggleInput,
  },
  data() {
    return {
      jobData: {
        title: 'Real Estate Agent',
        description:
          '<p><strong style="background-color: transparent;">Are you ready to seize an outstanding opportunity to advance your real estate career? {{team_name}} invites you to explore a realm of boundless potential!</strong></p><p><br></p><p><span style="background-color: transparent;">At {{team_name}}, we invite you to embark on a journey of professional growth and achievement that transcends the ordinary. Our team is facing an exciting challenge - we\'re inundated with leads! Month after month, our agents achieve remarkable success, all thanks to our technology-driven approach and aggressive internet lead generation system. It\'s no surprise that we stand tall as one of the fastest-growing real estate companies in the region.</span></p><p><br></p><p><strong style="background-color: transparent;">What sets {{team_name}} apart:</strong></p><p><br></p><ul><li><span style="background-color: transparent;">A Wealth of Quality LEADS: Say goodbye to the struggle of finding clients; we offer a constant flow of high-quality prospects.</span></li><li><span style="background-color: transparent;">First-Class Support: Our exceptional coaches and leadership team guide you to excellence with top-notch marketing materials and sales support.</span></li><li><span style="background-color: transparent;">Streamlined Paperwork: No more hassle with back-office paperwork; we handle it, allowing you to focus on being an agent.</span></li><li><span style="background-color: transparent;">Master the Art of Lead Conversion: Our proven training and tutoring program caters to all experience levels, transforming you into a lead conversion expert.</span></li></ul><p><br></p><p><strong style="background-color: transparent;">Are you the ideal fit for {{team_name}}?</strong></p><p><br></p><ul><li><span style="background-color: transparent;">A Self-Starter: Build a career, not just a job. We seek ambitious, self-motivated individuals for rewarding full-time sales positions as realtors!</span></li><li><span style="background-color: transparent;">Enthusiastic &amp; Helpful: If you enjoy connecting with others and have a passion for helping people, this career is tailor-made for you.</span></li><li><span style="background-color: transparent;">A Team Player: Success at {{team_name}} demands drive, energy, and an unwavering desire for success in a close-knit company where your efforts directly impact the bottom line.</span></li></ul><p><br></p><p><strong style="background-color: transparent;">As a Real Estate Agent with us, you\'ll make a significant impact:</strong></p><p><br></p><ul><li><span style="background-color: transparent;">Diligent Lead Follow-Up: Maximize sales opportunities through meticulous lead follow-up.</span></li><li><span style="background-color: transparent;">Nurture Client Relationships: Understand clients\' needs to generate more sales opportunities.</span></li><li><span style="background-color: transparent;">Expert Buyer &amp; Seller Consultations: Match clients with their dream homes through insightful consultations.</span></li><li><span style="background-color: transparent;">Showcase Listings: Host open houses to attract prospective buyers and showcase our listings.</span></li><li><span style="background-color: transparent;">Seamless Transaction Management: Oversee property transactions for a smooth experience for all parties.</span></li><li><span style="background-color: transparent;">Business Expansion: Leverage your expertise to attract new clients and grow our business.</span></li><li><span style="background-color: transparent;">Local Market Expertise: Possess in-depth local knowledge of the community and market conditions, ready to address client queries.</span></li></ul><p><br></p><p><strong style="background-color: transparent;">Qualifications:</strong></p><p><br></p><ul><li><span style="background-color: transparent;">Past Sales Experience (Preferred): Past sales experience is preferred but not mandatory.</span></li><li><span style="background-color: transparent;">Tech-Savvy: Embrace new tools and platforms in the tech-savvy world of real estate.</span></li><li><span style="background-color: transparent;">Exceptional Communication &amp; Networking: Master the art of communication, negotiation, and networking.</span></li><li><span style="background-color: transparent;">Driven &amp; Motivated: Display self-motivation, drive, and a readiness to overcome challenges.</span></li><li><span style="background-color: transparent;">Organized &amp; Time Management Pro: Maintain organization and excel in time management.</span></li><li><span style="background-color: transparent;">A Real Estate License (Mandatory)</span></li></ul><p><br></p><p><strong style="background-color: transparent;">While others slow down, {{team_name}} continues to soar! In an expanding real estate landscape, we thrive, and exceptional opportunities await you. Are you prepared to embrace growth and achievement? Apply now and step into a brighter future with us!</strong></p><p><br></p><p><strong>Job Type:</strong> </p><p>Full-time</p><p><br></p><p><strong>Pay:</strong> </p><p>$48,226.91 - $196,492.21 per year</p><p><br></p><p><strong>Benefits:</strong> </p><p>Flexible schedule</p><p><br></p><p><strong>Schedule:</strong> </p><p>Monday to Friday</p><p>Self-determined schedule</p><p>Weekend availability</p><p><br></p><p><strong>Supplemental pay types:</strong> </p><p>Bonus pay</p><p>Commission pay</p>',
        location: {
          city: '',
          state: '',
          country: '',
        },
        resume_required: false,
      },
      selectedTab: 'Humaniz Description',
      customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']],
      states: StatesUtility.getStates(),
    };
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    async createJob() {
      try {
        // Ensure we have location data before proceeding
        if (!this.jobData.location.city || !this.jobData.location.state) {
          throw new Error('Please select a valid location');
        }

        const jobPayload = {
          title: this.jobData.title,
          job_type: 'real_estate_agent',
          status: 'active',
          resume_required: this.jobData.resume_required,
          job_details: [
            {
              description: this.jobData.description,
              status: 'active',
            },
          ],
          job_locations: [
            {
              city: this.jobData.location.city,
              state: this.jobData.location.state,
              country: this.jobData.location.country || 'USA',
              latitude: this.jobData.location.latitude,
              longitude: this.jobData.location.longitude,
              status: 'active',
            },
          ],
        };

        const response = await createJob(jobPayload);

        this.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Job Created',
          alertDescription:
            'Your job was successfully created. Use the buttons below to view your new job, or dismiss this alert.',
        });

        if (response?.record?.id) {
          await this.$router.push({
            name: 'JobDetail',
            params: { id: response.record.id },
          });
        }
      } catch (error) {
        console.error('Failed to create job:', error);
        if (error.message === 'Please select a valid location') {
          this.$store.commit('general/showAlert', {
            alertType: 'error',
            alertTitle: 'Location Required',
            alertDescription: 'Please select a valid city and state from the location dropdown.',
          });
        }
      }
    },
  },
};
</script>
